module.exports = __webpack_public_path__ + "static/img/vd-6.044696a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m8/vd-6.png
// module id = sy+k
// module chunks = 1